import Vue from 'vue';
import PlaypositApi from '@/services/PlaylistService';

const VuePlaypositApi = {
  install(V) {
    V.$api = PlaypositApi;
    Object.defineProperties(Vue.prototype, {
      $api: {
        get() {
          return PlaypositApi;
        },
      },
    });
    if (typeof window !== 'undefined' && window.Vue) {
      window.Vue.use(VuePlaypositApi);
    }
  },
};

Vue.use(VuePlaypositApi);

export default Vue;
